import { LoadingCircle } from './Loading';
import Profile from '../assets/profile.svg';
import React from 'react';
import {User} from "../types/users";

type Anchor =
    | { type: "element"; el: HTMLElement }
    | { type: "point"; x: number; y: number }
    | null;

type Placement = "bottom-start" | "bottom-end" | "top-start" | "top-end" | "right-start" | "left-start";

export type AnchoredDropdownProps = {
    open: boolean;
    onClose: () => void;
    anchor: Anchor;
    placement?: Placement;
    // optional max width/height
    maxWidth?: number;
    maxHeight?: number;
    className?: string;
    children: React.ReactNode; // your <DropdownItem/>s or any content
};

interface ColleagueInfoPanelProps {
    user: User | null;
}

export const ColleagueInfoPanel: React.FC<ColleagueInfoPanelProps> = ({ user }) => {
    if (!user) return null;
    const isSuccess = true;

    // if (isLoading) return <LoadingCircle />; Todo

    if (isSuccess) return (
        <div className="w-[435px] rounded-lg p-0">
            <div className="flex flex-col relative">
                <div
                    className='
                        bg-melon-light-grey rounded
                        left-1 top-1 right-1 h-[101px]
                        -z-10 absolute
                    '
                ></div>
                <div className='text-center relative z-10 px-4'>
                    <img
                        className='rounded-[50%] mx-auto h-[100px] w-[100px] object-cover object-center mt-[30px] mb-3
                        border-4 border-white shadow-lg shadow-melon-light bg-melon-white'
                        src={user.photo_img?.file ?? Profile}
                        alt='avatar'
                    />
                    <div className='text-[20px] mt-7'>{user.last_name} {user.first_name} {user.middle_name}</div>
                    <div className='text-melon-grey-darker text-sm mt-[10px]'>{user.brand}</div>
                </div>
            </div>

            <div className="px-4 flex flex-col gap-1 mb-2 mt-[10px]">
                <div>
                    <div className='text-melon-grey-darker text-sm'>Телефон</div>
                    <div className='text-[16px]'>{user.phone}</div>
                </div>

                <div>
                    <div className='text-melon-grey-darker text-sm'>E-mail адрес</div>
                    <div className='text-[16px]'>{user.email}</div>
                </div>
            </div>
        </div>
    )

    return <img className='bg-white p-3 rounded-lg' src={Profile} alt='profile' />
};
